export enum EntityName {
    ASIC = 'ASIC',
    VFSC = 'VFSC',
    SCB = 'SCB',
    FCA = 'FCA',
    CYSEC = 'CYSEC',
    FCS = 'FCS',
    NONE = 'NONE',
}
